module.exports = {
  /* 01.General */
  "chat.end":"बातचीत समाप्त करें",
  "chat.endall":"बातचीत बंद करें",
  "chat.cancel":"रद्द करें",
  "chat.cookie":"यह डिजिटल सहायक यह सुनिश्चित करने के लिए कुकीज़ का उपयोग करता है कि आपको सबसे अच्छा अनुभव मिले",
  "chat.learn":"और अधिक जानें",
  "chat.minimize":"छोटा करें",
  "chat.hide":"बंद करें",
  "chat.hidebot.text":"करीब 15 मिनट के लिए अवतार गायब कर देगा।",
  "chat.hidebot":"बोट बंद करें",
  "chat.restart":"पुनर्प्रारंभ करें",
  "switch.language":"भाषा बदलें",
  "switch.property":"संपत्ति बदले",
  "restart.converstation":"वार्तालाप को पुनरारंभ करें",
  "chat.endtext":"क्या आप वाकई वर्तमान चैट को समाप्त करना चाहते हैं?",
  "check.availabity":"उपलब्धता जांचें",
  "check.availabity.submit":"प्रस्तुत करना",
  "check.availabity.cancel":"रद्द करें",
  "check.availabity.adults":"वयस्कों ",
  "check.availabity.children":"बच्चे",
  "check.availabity.child.age":"आयु - बच्चा",
  "feedback.leave":"प्रतिक्रिया दें",
  "feedback.leave.message":"संदेश छोड़ें",
};
